import { Tooltip } from 'antd';
import { useHistory } from 'troyfe';
import { imgUrlHandle } from '@/utils';

export default function Control ({ options }) {
  const {
    authenticationType,
    communityStatistics,
    userNum,
    adminData,
    sonData,
    identityType,
    projectObj,
    userInf,
    user,
    identityText,
  } = options;
  // const user = JSON.parse(sessionStorage.getItem('user'))
  const history = useHistory();
  let userText = '';
  let userText1 = '';
  if (user?.userName) {
    userText = user?.userName;
    userText1 =
      user?.userName?.length > 11
        ? `${user?.userName.slice(0, 11)}`
        : user?.userName;
  } else {
    userText = user?.phone;
    userText1 = user?.phone;
  }
  return (
    <div className="control-block">
      {/* 身份信息 */}
      <div className="control-user">
        <div className="control-inf">
          {/* <img
            src={
              user && user?.headUrl
                ? imgUrlHandle(user?.headUrl)
                : '/headPortrait.png'
            }
            alt="userImg"
          /> */}
          <div className="user-text">{userText}</div>
          <div className="control-text">
            <Tooltip placement="right" title={user?.userName}>
              <h1>
                您好,
                {userText1 || userInf.phone}
              </h1>
            </Tooltip>
            {projectObj?.creatorId ? (
              <div>
                你现在的身份是 <i />
                <span>
                  {identityText}
                  {/* {projectObj?.creatorId === userInf?.id
                    ? '创建者'
                    : '子管理员'} */}
                </span>
              </div>
            ) : (
              <div className="certifiedBuilding">
                您现在没有身份，创建楼盘信息可以获得新身份
                <span
                  onClick={() => {
                    history.push({
                      pathname: '/project/basicInformation',
                    });
                  }}
                >
                  立即创建物业项目
                </span>
              </div>
            )}
          </div>
        </div>
        {authenticationType && (
          <div className="control-admin">
            <div className="main">
              <h1>主管理员</h1>
              <ul>
                {adminData?.slice(0, 2).map((item, i) => {
                  return (
                    <li key={i} className="circular">
                      {item.userName}
                    </li>
                  );
                })}
                <li
                  className="more"
                  onClick={() => {
                    history.push({
                      pathname: '/systemSettings/authorityManage',
                      state: {
                        manageType: 'ZGLY',
                      },
                    });
                  }}
                >
                  ⋯
                </li>
                <li style={{ background: 'none', visibility: 'hidden' }} />
                <i style={{ height: 36 }} />
              </ul>
            </div>
            <div className="vice-">
              <h1>子管理员</h1>
              <ul>
                {sonData?.slice(0, 4).map((item, i) => {
                  return (
                    <li key={i} className="circular">
                      {item.userName}
                    </li>
                  );
                })}
                <li
                  className="more"
                  onClick={() => {
                    history.push({
                      pathname: '/systemSettings/authorityManage',
                      state: {
                        manageType: 'GLZ',
                      },
                    });
                  }}
                >
                  ⋯
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
      {/* 申请楼盘认证 */}
      {!authenticationType && (
        <div className="buildingAuthentication">
          <p>楼盘认证获得更多功能</p>
          <div className="limit">
            <div>
              <Tooltip title="OA审批,认证后可使用更多功能">
                <img src="/oa.png" alt="oa" />
              </Tooltip>
              <Tooltip title="物业收费,认证后可使用更多功能">
                <img src="/charge.png" alt="charge" />
              </Tooltip>
              <Tooltip title="合同,认证后可使用更多功能">
                <img src="contract.png" alt="contract" />
              </Tooltip>
            </div>
            <div
              className="button"
              onClick={() => {
                history.push({
                  pathname: '/project/basicInformation',
                  state: projectObj,
                });
              }}
            >
              申请项目认证
            </div>
          </div>
        </div>
      )}
      {/* 小区统计 */}
      {authenticationType && (
        <ul className="control-summary">
          <li>
            <label>楼栋</label>
            <br />
            <p>{userNum.building}</p>
          </li>
          <li>
            <label>房屋</label>
            <br />
            <p>{userNum.house}</p>
          </li>
          <li>
            <label>车位</label>
            <br />
            <p>{userNum.parking}</p>
          </li>
          <li>
            <label>常住人口数</label>
            <br />
            <p>{userNum.people}</p>
          </li>
        </ul>
      )}

      {/* 管理人数 */}
      {authenticationType && (
        <ul className="control-role">
          <li>
            <div>
              管理员人数
              {!authenticationType && <span>去添加</span>}
            </div>
            <p>{communityStatistics.adminTotal}</p>
          </li>
          <li>
            <div>
              部门数
              {!authenticationType && <span>去添加</span>}
            </div>
            <p>{communityStatistics.deptTotal}</p>
          </li>
          <li>
            <div>服务人员数</div>
            <p>{communityStatistics.servicerTotal}</p>
          </li>
          <li>
            <div>昨日使用人数</div>
            <p>{communityStatistics.usePeople}</p>
          </li>
        </ul>
      )}
    </div>
  );
}
